import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  imports: [CommonModule],
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.css',
})
export class ToggleSwitchComponent {
  @Input() checked = false; // Toggle state
  @Output() toggleChange = new EventEmitter<boolean>(); // Emits state change

  toggle() {
    this.checked = !this.checked;
    this.toggleChange.emit(this.checked);
  }

  isToggled = false;

handleToggle(event: boolean) {
  console.log('Toggled:', event);
}
}
